
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import AdminSidemenuLayout from '@/components/organisms/layout/AdminSidemenuLayout.vue'
import RegistDataPanel from '@/components/organisms/manage/RegistDataPanel.vue'
import AcademyListPanel from '@/components/organisms/manage/AcademyListPanel.vue'
import MenuEditAcademy from '@/components/organisms/floatmenu/MenuEditAcademy.vue'
import { AcademyList } from '@/models/manage/AcademyList'

/**
 * 塾一覧のレイアウト
 */
@Component({
  components: {
    ButtonBase,
    AdminSidemenuLayout,
    RegistDataPanel,
    AcademyListPanel,
    MenuEditAcademy,
  },
})
export default class AdminAcademyList extends Vue {
  /** サイドメニュー部 */
  @Ref()
  private adminSidemenuLayout!: AdminSidemenuLayout

  /** 塾一覧パネル */
  @Ref()
  private academyListPanel!: AcademyListPanel

  /** 塾一覧 */
  @Prop()
  private academyList!: AcademyList[]

  /** 編集メニュー */
  @Ref()
  private menuEditAcademy!: MenuEditAcademy

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** 塾登録ボタン押下時のイベント */
  @Prop()
  private eventClickCreateAcademyButton!: () => void

  /** 削除ボタン押下時のイベント */
  @Prop()
  private eventClickDeleteButton!: (academyId: number) => void

  /** 塾情報編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditAcademyButton!: (academyId: number, academyName: string) => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 編集ボタンクリック時の処理
   *
   * @param event イベント
   * @param academyId 対象塾ID
   */
  private async eventClickEditButton(event: Event, academyId: number): Promise<void> {
    await this.menuEditAcademy.show(
      event.target as HTMLElement,
      academyId,
      this.adminSidemenuLayout.sidemenuLayout.contentMain
    )
  }

  /**
   * 検索欄に入力された文字列
   *
   * @returns 入力された文字列
   */
  public textInputedSearch(): string {
    return this.academyListPanel.textInputed()
  }
}
